/**
 * mobile-pdp-accordions
 *
 * The PDP accordion stack is authored on the main product section, where it
 * renders in the product form column on desktop. On smaller screens the design
 * moves it further down the page, into its own section — this clones the
 * rendered markup rather than duplicating the section settings behind it.
 */
class MobilePdpAccordions extends HTMLElement {
  connectedCallback() {
    this.render();
  }

  render() {
    const source = document.querySelector(this.sourceSelector);

    if (!source) return;

    const clone = source.cloneNode(true);

    clone.classList.remove("pdp-accordions--desktop");
    clone.classList.add("pdp-accordions--mobile");

    // Keep this copy out of the source's accordion group (and out of any future
    // clone's search for a source) so the two stacks toggle independently.
    clone.removeAttribute("data-pdp-accordions");
    clone.querySelectorAll("[accordion-group]").forEach((item) => {
      const group = item.getAttribute("accordion-group");
      item.setAttribute("accordion-group", `${group}-mobile`);
    });

    this.replaceChildren(clone);
  }

  get sourceSelector() {
    return this.getAttribute("source") || "[data-pdp-accordions]";
  }
}

if (!customElements.get("mobile-pdp-accordions")) {
  customElements.define("mobile-pdp-accordions", MobilePdpAccordions);
}
